import * as yup from "yup";

export const preferredICFormSchema = yup.object({
  preferred_ic: yup.string(),
  preferred_product: yup.string(),
});
